


















import { computed, defineComponent, onUnmounted } from '@vue/composition-api'
import StoreUtil from '@/store/StoreUtil'
import LoadingOverlayProgressParts from '@/components/sections/LoadingOverlay/parts/LoadingOverlayProgressParts.vue'

/**
 * 共通ローディングオーバーレイの進捗表示に使用するセクション
 */
export default defineComponent({
  name: 'LoadingOverlayProgressSection',
  components: {
    LoadingOverlayProgressParts,
  },
  setup() {
    const loadingOverLayStore = StoreUtil.useStore('LoadingOverlayProgressStore')

    // 進捗状況リスト
    const progressList = computed(() => loadingOverLayStore.state.progressList)
    // 注意メッセージ
    const cautionMessage = computed(() => loadingOverLayStore.state.cautionMessage)
    // ボタンのラベル
    const buttonLabel = computed(() => loadingOverLayStore.state.buttonLabel)

    onUnmounted(() => {
      loadingOverLayStore.clearLoadingOverLayData()
    })

    return {
      progressList,
      cautionMessage,
      buttonLabel,
      setPressedButton: loadingOverLayStore.setPressedButton,
    }
  },
  methods: {
    handleButtonClicked() {
      this.setPressedButton(true)
    },
  },
})
